export const GalleryData = [
  {
    id: 1,
    name: "Bali",
    titile: "budget-friendly",
    image: "./images/bali.jpg",
    link: "https://634bac50f9362145e475b955--harmonious-sable-45705f.netlify.app/balipage",
  },
  {
    id: 2,
    name: "Grand Canyon",
    titile: "budget-friendly",
    image: "./images/grandcanyon.jpg",
    link: "https://634bac50f9362145e475b955--harmonious-sable-45705f.netlify.app/grandcanyonpage",
  },
  {
    id: 3,
    name: "London",
    titile: "budget-friendly",
    image: "./images/london.jpg",
    link: "https://634bac50f9362145e475b955--harmonious-sable-45705f.netlify.app/londonpage",
  },
  {
    id: 4,
    name: "Prague",
    titile: "budget-friendly",
    image: "./images/prague.jpg",
    link: "https://634bac50f9362145e475b955--harmonious-sable-45705f.netlify.app/praguepage",
  },
  {
    id: 5,
    name: "Rome",
    titile: "peaceful",
    image: "./images/rome.jpg",
    link: "https://634bac50f9362145e475b955--harmonious-sable-45705f.netlify.app/romepage%20copy",
  },
  {
    id: 6,
    name: "Santorini",
    titile: "peaceful",
    image: "./images/santorini.jpg",
    link: "https://634bac50f9362145e475b955--harmonious-sable-45705f.netlify.app/santamariapage",
  },
  {
    id: 7,
    name: "Taj Mahal",
    titile: "nature",
    image: "./images/tajmahal.jpg",
    link: "https://634bac50f9362145e475b955--harmonious-sable-45705f.netlify.app/agrapage",
  },
  {
    id: 8,
    name: "Qutub Minar",
    titile: "nature",
    image: "./images/qutab-minar.jpg",
    link: "https://634bac50f9362145e475b955--harmonious-sable-45705f.netlify.app/newdelhipage",
  },
];
